import React from 'react';
import { Text } from '@rsos/components/capstone/base';
import Loader from '@rsos/components/capstone/base/Button/Loader';
import { AgencyNameContainer } from '../InviteAgencyModal.styles';

const IsFetching = () => (
  <AgencyNameContainer>
    <Loader color="secondaryText" size={14} />{' '}
    <Text color="secondaryText" data-name="is-fetching" size="normal">
      Fetching available agencies
    </Text>
  </AgencyNameContainer>
);

export default IsFetching;
